import Color from 'colorjs.io';
import { ReferenceColors } from '../models/theming';

export const referenceColors: ReferenceColors = {
  chromatic: {
    light: {
      tomato: [
        new Color('color(display-p3 0.998 0.989 0.988)').to('oklch'),
        new Color('color(display-p3 0.994 0.974 0.969)').to('oklch'),
        new Color('color(display-p3 0.985 0.924 0.909)').to('oklch'),
        new Color('color(display-p3 0.996 0.868 0.835)').to('oklch'),
        new Color('color(display-p3 0.98 0.812 0.77)').to('oklch'),
        new Color('color(display-p3 0.953 0.75 0.698)').to('oklch'),
        new Color('color(display-p3 0.917 0.673 0.611)').to('oklch'),
        new Color('color(display-p3 0.875 0.575 0.502)').to('oklch'),
        new Color('color(display-p3 0.831 0.345 0.231)').to('oklch'),
        new Color('color(display-p3 0.802 0.313 0.2)').to('oklch'),
        new Color('color(display-p3 0.755 0.259 0.152)').to('oklch'),
        new Color('color(display-p3 0.335 0.165 0.132)').to('oklch'),
      ],
      red: [
        new Color('color(display-p3 0.998 0.989 0.988)').to('oklch'),
        new Color('color(display-p3 0.995 0.971 0.971)').to('oklch'),
        new Color('color(display-p3 0.985 0.925 0.925)').to('oklch'),
        new Color('color(display-p3 0.999 0.866 0.866)').to('oklch'),
        new Color('color(display-p3 0.984 0.812 0.811)').to('oklch'),
        new Color('color(display-p3 0.955 0.751 0.749)').to('oklch'),
        new Color('color(display-p3 0.915 0.675 0.672)').to('oklch'),
        new Color('color(display-p3 0.872 0.575 0.572)').to('oklch'),
        new Color('color(display-p3 0.83 0.329 0.324)').to('oklch'),
        new Color('color(display-p3 0.798 0.294 0.285)').to('oklch'),
        new Color('color(display-p3 0.744 0.234 0.222)').to('oklch'),
        new Color('color(display-p3 0.36 0.115 0.143)').to('oklch'),
      ],
      ruby: [
        new Color('color(display-p3 0.998 0.989 0.992)').to('oklch'),
        new Color('color(display-p3 0.995 0.971 0.974)').to('oklch'),
        new Color('color(display-p3 0.983 0.92 0.928)').to('oklch'),
        new Color('color(display-p3 0.987 0.869 0.885)').to('oklch'),
        new Color('color(display-p3 0.968 0.817 0.839)').to('oklch'),
        new Color('color(display-p3 0.937 0.758 0.786)').to('oklch'),
        new Color('color(display-p3 0.897 0.685 0.721)').to('oklch'),
        new Color('color(display-p3 0.851 0.588 0.639)').to('oklch'),
        new Color('color(display-p3 0.83 0.323 0.408)').to('oklch'),
        new Color('color(display-p3 0.795 0.286 0.375)').to('oklch'),
        new Color('color(display-p3 0.728 0.211 0.311)').to('oklch'),
        new Color('color(display-p3 0.36 0.115 0.171)').to('oklch'),
      ],
      crimson: [
        new Color('color(display-p3 0.998 0.989 0.992)').to('oklch'),
        new Color('color(display-p3 0.991 0.969 0.976)').to('oklch'),
        new Color('color(display-p3 0.987 0.917 0.941)').to('oklch'),
        new Color('color(display-p3 0.975 0.866 0.904)').to('oklch'),
        new Color('color(display-p3 0.953 0.813 0.864)').to('oklch'),
        new Color('color(display-p3 0.921 0.755 0.817)').to('oklch'),
        new Color('color(display-p3 0.88 0.683 0.761)').to('oklch'),
        new Color('color(display-p3 0.834 0.592 0.694)').to('oklch'),
        new Color('color(display-p3 0.843 0.298 0.507)').to('oklch'),
        new Color('color(display-p3 0.807 0.266 0.468)').to('oklch'),
        new Color('color(display-p3 0.731 0.195 0.388)').to('oklch'),
        new Color('color(display-p3 0.352 0.111 0.221)').to('oklch'),
      ],
      pink: [
        new Color('color(display-p3 0.998 0.989 0.996)').to('oklch'),
        new Color('color(display-p3 0.992 0.97 0.985)').to('oklch'),
        new Color('color(display-p3 0.981 0.917 0.96)').to('oklch'),
        new Color('color(display-p3 0.963 0.867 0.932)').to('oklch'),
        new Color('color(display-p3 0.939 0.815 0.899)').to('oklch'),
        new Color('color(display-p3 0.907 0.756 0.859)').to('oklch'),
        new Color('color(display-p3 0.869 0.683 0.81)').to('oklch'),
        new Color('color(display-p3 0.825 0.59 0.751)').to('oklch'),
        new Color('color(display-p3 0.775 0.297 0.61)').to('oklch'),
        new Color('color(display-p3 0.748 0.27 0.581)').to('oklch'),
        new Color('color(display-p3 0.698 0.219 0.528)').to('oklch'),
        new Color('color(display-p3 0.363 0.101 0.279)').to('oklch'),
      ],
      plum: [
        new Color('color(display-p3 0.995 0.988 0.999)').to('oklch'),
        new Color('color(display-p3 0.988 0.971 0.99)').to('oklch'),
        new Color('color(display-p3 0.973 0.923 0.98)').to('oklch'),
        new Color('color(display-p3 0.953 0.875 0.966)').to('oklch'),
        new Color('color(display-p3 0.926 0.825 0.945)').to('oklch'),
        new Color('color(display-p3 0.89 0.765 0.916)').to('oklch'),
        new Color('color(display-p3 0.84 0.686 0.877)').to('oklch'),
        new Color('color(display-p3 0.775 0.58 0.832)').to('oklch'),
        new Color('color(display-p3 0.624 0.313 0.708)').to('oklch'),
        new Color('color(display-p3 0.587 0.29 0.667)').to('oklch'),
        new Color('color(display-p3 0.543 0.263 0.619)').to('oklch'),
        new Color('color(display-p3 0.299 0.114 0.352)').to('oklch'),
      ],
      purple: [
        new Color('color(display-p3 0.995 0.988 0.996)').to('oklch'),
        new Color('color(display-p3 0.983 0.971 0.993)').to('oklch'),
        new Color('color(display-p3 0.963 0.931 0.989)').to('oklch'),
        new Color('color(display-p3 0.937 0.888 0.981)').to('oklch'),
        new Color('color(display-p3 0.904 0.837 0.966)').to('oklch'),
        new Color('color(display-p3 0.86 0.774 0.942)').to('oklch'),
        new Color('color(display-p3 0.799 0.69 0.91)').to('oklch'),
        new Color('color(display-p3 0.719 0.583 0.874)').to('oklch'),
        new Color('color(display-p3 0.523 0.318 0.751)').to('oklch'),
        new Color('color(display-p3 0.483 0.289 0.7)').to('oklch'),
        new Color('color(display-p3 0.473 0.281 0.687)').to('oklch'),
        new Color('color(display-p3 0.234 0.132 0.363)').to('oklch'),
      ],
      violet: [
        new Color('color(display-p3 0.991 0.988 0.995)').to('oklch'),
        new Color('color(display-p3 0.978 0.974 0.998)').to('oklch'),
        new Color('color(display-p3 0.953 0.943 0.993)').to('oklch'),
        new Color('color(display-p3 0.916 0.897 1)').to('oklch'),
        new Color('color(display-p3 0.876 0.851 1)').to('oklch'),
        new Color('color(display-p3 0.825 0.793 0.981)').to('oklch'),
        new Color('color(display-p3 0.752 0.712 0.943)').to('oklch'),
        new Color('color(display-p3 0.654 0.602 0.902)').to('oklch'),
        new Color('color(display-p3 0.417 0.341 0.784)').to('oklch'),
        new Color('color(display-p3 0.381 0.306 0.741)').to('oklch'),
        new Color('color(display-p3 0.383 0.317 0.702)').to('oklch'),
        new Color('color(display-p3 0.179 0.15 0.359)').to('oklch'),
      ],
      iris: [
        new Color('color(display-p3 0.992 0.992 0.999)').to('oklch'),
        new Color('color(display-p3 0.972 0.973 0.998)').to('oklch'),
        new Color('color(display-p3 0.943 0.945 0.992)').to('oklch'),
        new Color('color(display-p3 0.902 0.906 1)').to('oklch'),
        new Color('color(display-p3 0.857 0.861 1)').to('oklch'),
        new Color('color(display-p3 0.799 0.805 0.987)').to('oklch'),
        new Color('color(display-p3 0.721 0.727 0.955)').to('oklch'),
        new Color('color(display-p3 0.61 0.619 0.918)').to('oklch'),
        new Color('color(display-p3 0.357 0.357 0.81)').to('oklch'),
        new Color('color(display-p3 0.318 0.318 0.774)').to('oklch'),
        new Color('color(display-p3 0.337 0.326 0.748)').to('oklch'),
        new Color('color(display-p3 0.154 0.161 0.371)').to('oklch'),
      ],
      indigo: [
        new Color('color(display-p3 0.992 0.992 0.996)').to('oklch'),
        new Color('color(display-p3 0.971 0.977 0.998)').to('oklch'),
        new Color('color(display-p3 0.933 0.948 0.992)').to('oklch'),
        new Color('color(display-p3 0.885 0.914 1)').to('oklch'),
        new Color('color(display-p3 0.831 0.87 1)').to('oklch'),
        new Color('color(display-p3 0.767 0.814 0.995)').to('oklch'),
        new Color('color(display-p3 0.685 0.74 0.957)').to('oklch'),
        new Color('color(display-p3 0.569 0.639 0.916)').to('oklch'),
        new Color('color(display-p3 0.276 0.384 0.837)').to('oklch'),
        new Color('color(display-p3 0.234 0.343 0.801)').to('oklch'),
        new Color('color(display-p3 0.256 0.354 0.755)').to('oklch'),
        new Color('color(display-p3 0.133 0.175 0.348)').to('oklch'),
      ],
      blue: [
        new Color('color(display-p3 0.986 0.992 0.999)').to('oklch'),
        new Color('color(display-p3 0.96 0.979 0.998)').to('oklch'),
        new Color('color(display-p3 0.912 0.956 0.991)').to('oklch'),
        new Color('color(display-p3 0.853 0.932 1)').to('oklch'),
        new Color('color(display-p3 0.788 0.894 0.998)').to('oklch'),
        new Color('color(display-p3 0.709 0.843 0.976)').to('oklch'),
        new Color('color(display-p3 0.606 0.777 0.947)').to('oklch'),
        new Color('color(display-p3 0.451 0.688 0.917)').to('oklch'),
        new Color('color(display-p3 0.247 0.556 0.969)').to('oklch'),
        new Color('color(display-p3 0.234 0.523 0.912)').to('oklch'),
        new Color('color(display-p3 0.15 0.44 0.84)').to('oklch'),
        new Color('color(display-p3 0.102 0.193 0.379)').to('oklch'),
      ],
      cyan: [
        new Color('color(display-p3 0.982 0.992 0.996)').to('oklch'),
        new Color('color(display-p3 0.955 0.981 0.984)').to('oklch'),
        new Color('color(display-p3 0.888 0.965 0.975)').to('oklch'),
        new Color('color(display-p3 0.821 0.941 0.959)').to('oklch'),
        new Color('color(display-p3 0.751 0.907 0.935)').to('oklch'),
        new Color('color(display-p3 0.671 0.862 0.9)').to('oklch'),
        new Color('color(display-p3 0.564 0.8 0.854)').to('oklch'),
        new Color('color(display-p3 0.388 0.715 0.798)').to('oklch'),
        new Color('color(display-p3 0.282 0.627 0.765)').to('oklch'),
        new Color('color(display-p3 0.264 0.583 0.71)').to('oklch'),
        new Color('color(display-p3 0.08 0.48 0.63)').to('oklch'),
        new Color('color(display-p3 0.108 0.232 0.277)').to('oklch'),
      ],
      teal: [
        new Color('color(display-p3 0.983 0.996 0.992)').to('oklch'),
        new Color('color(display-p3 0.958 0.983 0.976)').to('oklch'),
        new Color('color(display-p3 0.895 0.971 0.952)').to('oklch'),
        new Color('color(display-p3 0.831 0.949 0.92)').to('oklch'),
        new Color('color(display-p3 0.761 0.914 0.878)').to('oklch'),
        new Color('color(display-p3 0.682 0.864 0.825)').to('oklch'),
        new Color('color(display-p3 0.581 0.798 0.756)').to('oklch'),
        new Color('color(display-p3 0.433 0.716 0.671)').to('oklch'),
        new Color('color(display-p3 0.297 0.637 0.581)').to('oklch'),
        new Color('color(display-p3 0.275 0.599 0.542)').to('oklch'),
        new Color('color(display-p3 0.08 0.5 0.43)').to('oklch'),
        new Color('color(display-p3 0.11 0.235 0.219)').to('oklch'),
      ],
      jade: [
        new Color('color(display-p3 0.986 0.996 0.992)').to('oklch'),
        new Color('color(display-p3 0.962 0.983 0.969)').to('oklch'),
        new Color('color(display-p3 0.912 0.965 0.932)').to('oklch'),
        new Color('color(display-p3 0.858 0.941 0.893)').to('oklch'),
        new Color('color(display-p3 0.795 0.909 0.847)').to('oklch'),
        new Color('color(display-p3 0.715 0.864 0.791)').to('oklch'),
        new Color('color(display-p3 0.603 0.802 0.718)').to('oklch'),
        new Color('color(display-p3 0.44 0.72 0.629)').to('oklch'),
        new Color('color(display-p3 0.319 0.63 0.521)').to('oklch'),
        new Color('color(display-p3 0.299 0.592 0.488)').to('oklch'),
        new Color('color(display-p3 0.15 0.5 0.37)').to('oklch'),
        new Color('color(display-p3 0.142 0.229 0.194)').to('oklch'),
      ],
      green: [
        new Color('color(display-p3 0.986 0.996 0.989)').to('oklch'),
        new Color('color(display-p3 0.963 0.983 0.967)').to('oklch'),
        new Color('color(display-p3 0.913 0.964 0.925)').to('oklch'),
        new Color('color(display-p3 0.859 0.94 0.879)').to('oklch'),
        new Color('color(display-p3 0.796 0.907 0.826)').to('oklch'),
        new Color('color(display-p3 0.718 0.863 0.761)').to('oklch'),
        new Color('color(display-p3 0.61 0.801 0.675)').to('oklch'),
        new Color('color(display-p3 0.451 0.715 0.559)').to('oklch'),
        new Color('color(display-p3 0.332 0.634 0.442)').to('oklch'),
        new Color('color(display-p3 0.308 0.595 0.417)').to('oklch'),
        new Color('color(display-p3 0.19 0.5 0.32)').to('oklch'),
        new Color('color(display-p3 0.132 0.228 0.18)').to('oklch'),
      ],
      grass: [
        new Color('color(display-p3 0.986 0.996 0.985)').to('oklch'),
        new Color('color(display-p3 0.966 0.983 0.964)').to('oklch'),
        new Color('color(display-p3 0.923 0.965 0.917)').to('oklch'),
        new Color('color(display-p3 0.872 0.94 0.865)').to('oklch'),
        new Color('color(display-p3 0.811 0.908 0.802)').to('oklch'),
        new Color('color(display-p3 0.733 0.864 0.724)').to('oklch'),
        new Color('color(display-p3 0.628 0.803 0.622)').to('oklch'),
        new Color('color(display-p3 0.477 0.72 0.482)').to('oklch'),
        new Color('color(display-p3 0.38 0.647 0.378)').to('oklch'),
        new Color('color(display-p3 0.344 0.598 0.342)').to('oklch'),
        new Color('color(display-p3 0.263 0.488 0.261)').to('oklch'),
        new Color('color(display-p3 0.151 0.233 0.153)').to('oklch'),
      ],
      brown: [
        new Color('color(display-p3 0.995 0.992 0.989)').to('oklch'),
        new Color('color(display-p3 0.987 0.976 0.964)').to('oklch'),
        new Color('color(display-p3 0.959 0.936 0.909)').to('oklch'),
        new Color('color(display-p3 0.934 0.897 0.855)').to('oklch'),
        new Color('color(display-p3 0.909 0.856 0.798)').to('oklch'),
        new Color('color(display-p3 0.88 0.808 0.73)').to('oklch'),
        new Color('color(display-p3 0.841 0.742 0.639)').to('oklch'),
        new Color('color(display-p3 0.782 0.647 0.514)').to('oklch'),
        new Color('color(display-p3 0.651 0.505 0.368)').to('oklch'),
        new Color('color(display-p3 0.601 0.465 0.344)').to('oklch'),
        new Color('color(display-p3 0.485 0.374 0.288)').to('oklch'),
        new Color('color(display-p3 0.236 0.202 0.183)').to('oklch'),
      ],
      bronze: [
        new Color('color(display-p3 0.991 0.988 0.988)').to('oklch'),
        new Color('color(display-p3 0.989 0.97 0.961)').to('oklch'),
        new Color('color(display-p3 0.958 0.932 0.919)').to('oklch'),
        new Color('color(display-p3 0.929 0.894 0.877)').to('oklch'),
        new Color('color(display-p3 0.898 0.853 0.832)').to('oklch'),
        new Color('color(display-p3 0.861 0.805 0.778)').to('oklch'),
        new Color('color(display-p3 0.812 0.739 0.706)').to('oklch'),
        new Color('color(display-p3 0.741 0.647 0.606)').to('oklch'),
        new Color('color(display-p3 0.611 0.507 0.455)').to('oklch'),
        new Color('color(display-p3 0.563 0.461 0.414)').to('oklch'),
        new Color('color(display-p3 0.471 0.373 0.336)').to('oklch'),
        new Color('color(display-p3 0.251 0.191 0.172)').to('oklch'),
      ],
      gold: [
        new Color('color(display-p3 0.992 0.992 0.989)').to('oklch'),
        new Color('color(display-p3 0.98 0.976 0.953)').to('oklch'),
        new Color('color(display-p3 0.947 0.94 0.909)').to('oklch'),
        new Color('color(display-p3 0.914 0.904 0.865)').to('oklch'),
        new Color('color(display-p3 0.88 0.865 0.816)').to('oklch'),
        new Color('color(display-p3 0.84 0.818 0.756)').to('oklch'),
        new Color('color(display-p3 0.788 0.753 0.677)').to('oklch'),
        new Color('color(display-p3 0.715 0.66 0.565)').to('oklch'),
        new Color('color(display-p3 0.579 0.517 0.41)').to('oklch'),
        new Color('color(display-p3 0.538 0.479 0.38)').to('oklch'),
        new Color('color(display-p3 0.433 0.386 0.305)').to('oklch'),
        new Color('color(display-p3 0.227 0.209 0.173)').to('oklch'),
      ],
      sky: [
        new Color('color(display-p3 0.98 0.995 0.999)').to('oklch'),
        new Color('color(display-p3 0.953 0.98 0.99)').to('oklch'),
        new Color('color(display-p3 0.899 0.963 0.989)').to('oklch'),
        new Color('color(display-p3 0.842 0.937 0.977)').to('oklch'),
        new Color('color(display-p3 0.777 0.9 0.954)').to('oklch'),
        new Color('color(display-p3 0.701 0.851 0.921)').to('oklch'),
        new Color('color(display-p3 0.604 0.785 0.879)').to('oklch'),
        new Color('color(display-p3 0.457 0.696 0.829)').to('oklch'),
        new Color('color(display-p3 0.585 0.877 0.983)').to('oklch'),
        new Color('color(display-p3 0.555 0.845 0.959)').to('oklch'),
        new Color('color(display-p3 0.193 0.448 0.605)').to('oklch'),
        new Color('color(display-p3 0.145 0.241 0.329)').to('oklch'),
      ],
      mint: [
        new Color('color(display-p3 0.98 0.995 0.992)').to('oklch'),
        new Color('color(display-p3 0.957 0.985 0.977)').to('oklch'),
        new Color('color(display-p3 0.888 0.972 0.95)').to('oklch'),
        new Color('color(display-p3 0.819 0.951 0.916)').to('oklch'),
        new Color('color(display-p3 0.747 0.918 0.873)').to('oklch'),
        new Color('color(display-p3 0.668 0.87 0.818)').to('oklch'),
        new Color('color(display-p3 0.567 0.805 0.744)').to('oklch'),
        new Color('color(display-p3 0.42 0.724 0.649)').to('oklch'),
        new Color('color(display-p3 0.62 0.908 0.834)').to('oklch'),
        new Color('color(display-p3 0.585 0.871 0.797)').to('oklch'),
        new Color('color(display-p3 0.203 0.463 0.397)').to('oklch'),
        new Color('color(display-p3 0.136 0.259 0.236)').to('oklch'),
      ],
      lime: [
        new Color('color(display-p3 0.989 0.992 0.981)').to('oklch'),
        new Color('color(display-p3 0.975 0.98 0.954)').to('oklch'),
        new Color('color(display-p3 0.939 0.965 0.851)').to('oklch'),
        new Color('color(display-p3 0.896 0.94 0.76)').to('oklch'),
        new Color('color(display-p3 0.843 0.903 0.678)').to('oklch'),
        new Color('color(display-p3 0.778 0.852 0.599)').to('oklch'),
        new Color('color(display-p3 0.694 0.784 0.508)').to('oklch'),
        new Color('color(display-p3 0.585 0.707 0.378)').to('oklch'),
        new Color('color(display-p3 0.78 0.928 0.466)').to('oklch'),
        new Color('color(display-p3 0.734 0.896 0.397)').to('oklch'),
        new Color('color(display-p3 0.386 0.482 0.227)').to('oklch'),
        new Color('color(display-p3 0.222 0.25 0.128)').to('oklch'),
      ],
      yellow: [
        new Color('color(display-p3 0.992 0.992 0.978)').to('oklch'),
        new Color('color(display-p3 0.995 0.99 0.922)').to('oklch'),
        new Color('color(display-p3 0.997 0.982 0.749)').to('oklch'),
        new Color('color(display-p3 0.992 0.953 0.627)').to('oklch'),
        new Color('color(display-p3 0.984 0.91 0.51)').to('oklch'),
        new Color('color(display-p3 0.934 0.847 0.474)').to('oklch'),
        new Color('color(display-p3 0.876 0.785 0.46)').to('oklch'),
        new Color('color(display-p3 0.811 0.689 0.313)').to('oklch'),
        new Color('color(display-p3 1 0.92 0.22)').to('oklch'),
        new Color('color(display-p3 0.977 0.868 0.291)').to('oklch'),
        new Color('color(display-p3 0.6 0.44 0)').to('oklch'),
        new Color('color(display-p3 0.271 0.233 0.137)').to('oklch'),
      ],
      amber: [
        new Color('color(display-p3 0.995 0.992 0.985)').to('oklch'),
        new Color('color(display-p3 0.994 0.986 0.921)').to('oklch'),
        new Color('color(display-p3 0.994 0.969 0.782)').to('oklch'),
        new Color('color(display-p3 0.989 0.937 0.65)').to('oklch'),
        new Color('color(display-p3 0.97 0.902 0.527)').to('oklch'),
        new Color('color(display-p3 0.936 0.844 0.506)').to('oklch'),
        new Color('color(display-p3 0.89 0.762 0.443)').to('oklch'),
        new Color('color(display-p3 0.85 0.65 0.3)').to('oklch'),
        new Color('color(display-p3 1 0.77 0.26)').to('oklch'),
        new Color('color(display-p3 0.959 0.741 0.274)').to('oklch'),
        new Color('color(display-p3 0.64 0.4 0)').to('oklch'),
        new Color('color(display-p3 0.294 0.208 0.145)').to('oklch'),
      ],
      orange: [
        new Color('color(display-p3 0.995 0.988 0.985)').to('oklch'),
        new Color('color(display-p3 0.994 0.968 0.934)').to('oklch'),
        new Color('color(display-p3 0.989 0.938 0.85)').to('oklch'),
        new Color('color(display-p3 1 0.874 0.687)').to('oklch'),
        new Color('color(display-p3 1 0.821 0.583)').to('oklch'),
        new Color('color(display-p3 0.975 0.767 0.545)').to('oklch'),
        new Color('color(display-p3 0.919 0.693 0.486)').to('oklch'),
        new Color('color(display-p3 0.877 0.597 0.379)').to('oklch'),
        new Color('color(display-p3 0.9 0.45 0.2)').to('oklch'),
        new Color('color(display-p3 0.87 0.409 0.164)').to('oklch'),
        new Color('color(display-p3 0.76 0.34 0)').to('oklch'),
        new Color('color(display-p3 0.323 0.185 0.127)').to('oklch'),
      ],
    },
    dark: {
      tomato: [
        new Color('color(display-p3 0.09 0.068 0.067)').to('oklch'),
        new Color('color(display-p3 0.115 0.084 0.076)').to('oklch'),
        new Color('color(display-p3 0.205 0.097 0.083)').to('oklch'),
        new Color('color(display-p3 0.282 0.099 0.077)').to('oklch'),
        new Color('color(display-p3 0.339 0.129 0.101)').to('oklch'),
        new Color('color(display-p3 0.398 0.179 0.141)').to('oklch'),
        new Color('color(display-p3 0.487 0.245 0.194)').to('oklch'),
        new Color('color(display-p3 0.629 0.322 0.248)').to('oklch'),
        new Color('color(display-p3 0.831 0.345 0.231)').to('oklch'),
        new Color('color(display-p3 0.862 0.415 0.298)').to('oklch'),
        new Color('color(display-p3 1 0.585 0.455)').to('oklch'),
        new Color('color(display-p3 0.959 0.833 0.802)').to('oklch'),
      ],
      red: [
        new Color('color(display-p3 0.093 0.068 0.067)').to('oklch'),
        new Color('color(display-p3 0.118 0.077 0.079)').to('oklch'),
        new Color('color(display-p3 0.211 0.081 0.099)').to('oklch'),
        new Color('color(display-p3 0.287 0.079 0.113)').to('oklch'),
        new Color('color(display-p3 0.348 0.11 0.142)').to('oklch'),
        new Color('color(display-p3 0.414 0.16 0.183)').to('oklch'),
        new Color('color(display-p3 0.508 0.224 0.236)').to('oklch'),
        new Color('color(display-p3 0.659 0.298 0.297)').to('oklch'),
        new Color('color(display-p3 0.83 0.329 0.324)').to('oklch'),
        new Color('color(display-p3 0.861 0.403 0.387)').to('oklch'),
        new Color('color(display-p3 1 0.57 0.55)').to('oklch'),
        new Color('color(display-p3 0.971 0.826 0.852)').to('oklch'),
      ],
      ruby: [
        new Color('color(display-p3 0.093 0.068 0.074)').to('oklch'),
        new Color('color(display-p3 0.113 0.083 0.089)').to('oklch'),
        new Color('color(display-p3 0.208 0.088 0.117)').to('oklch'),
        new Color('color(display-p3 0.279 0.092 0.147)').to('oklch'),
        new Color('color(display-p3 0.337 0.12 0.18)').to('oklch'),
        new Color('color(display-p3 0.401 0.166 0.223)').to('oklch'),
        new Color('color(display-p3 0.495 0.224 0.281)').to('oklch'),
        new Color('color(display-p3 0.652 0.295 0.359)').to('oklch'),
        new Color('color(display-p3 0.83 0.323 0.408)').to('oklch'),
        new Color('color(display-p3 0.857 0.392 0.455)').to('oklch'),
        new Color('color(display-p3 1 0.57 0.59)').to('oklch'),
        new Color('color(display-p3 0.968 0.83 0.88)').to('oklch'),
      ],
      crimson: [
        new Color('color(display-p3 0.093 0.068 0.078)').to('oklch'),
        new Color('color(display-p3 0.117 0.078 0.095)').to('oklch'),
        new Color('color(display-p3 0.203 0.091 0.143)').to('oklch'),
        new Color('color(display-p3 0.277 0.087 0.182)').to('oklch'),
        new Color('color(display-p3 0.332 0.115 0.22)').to('oklch'),
        new Color('color(display-p3 0.394 0.162 0.268)').to('oklch'),
        new Color('color(display-p3 0.489 0.222 0.336)').to('oklch'),
        new Color('color(display-p3 0.638 0.289 0.429)').to('oklch'),
        new Color('color(display-p3 0.843 0.298 0.507)').to('oklch'),
        new Color('color(display-p3 0.864 0.364 0.539)').to('oklch'),
        new Color('color(display-p3 1 0.56 0.66)').to('oklch'),
        new Color('color(display-p3 0.966 0.834 0.906)').to('oklch'),
      ],
      pink: [
        new Color('color(display-p3 0.093 0.068 0.089)').to('oklch'),
        new Color('color(display-p3 0.121 0.073 0.11)').to('oklch'),
        new Color('color(display-p3 0.198 0.098 0.179)').to('oklch'),
        new Color('color(display-p3 0.271 0.095 0.231)').to('oklch'),
        new Color('color(display-p3 0.32 0.127 0.273)').to('oklch'),
        new Color('color(display-p3 0.382 0.177 0.326)').to('oklch'),
        new Color('color(display-p3 0.477 0.238 0.405)').to('oklch'),
        new Color('color(display-p3 0.612 0.304 0.51)').to('oklch'),
        new Color('color(display-p3 0.775 0.297 0.61)').to('oklch'),
        new Color('color(display-p3 0.808 0.356 0.645)').to('oklch'),
        new Color('color(display-p3 1 0.535 0.78)').to('oklch'),
        new Color('color(display-p3 0.964 0.826 0.912)').to('oklch'),
      ],
      plum: [
        new Color('color(display-p3 0.09 0.068 0.092)').to('oklch'),
        new Color('color(display-p3 0.118 0.077 0.121)').to('oklch'),
        new Color('color(display-p3 0.192 0.105 0.202)').to('oklch'),
        new Color('color(display-p3 0.25 0.121 0.271)').to('oklch'),
        new Color('color(display-p3 0.293 0.152 0.319)').to('oklch'),
        new Color('color(display-p3 0.343 0.198 0.372)').to('oklch'),
        new Color('color(display-p3 0.424 0.262 0.461)').to('oklch'),
        new Color('color(display-p3 0.54 0.341 0.595)').to('oklch'),
        new Color('color(display-p3 0.624 0.313 0.708)').to('oklch'),
        new Color('color(display-p3 0.666 0.365 0.748)').to('oklch'),
        new Color('color(display-p3 0.86 0.602 0.933)').to('oklch'),
        new Color('color(display-p3 0.936 0.836 0.949)').to('oklch'),
      ],
      purple: [
        new Color('color(display-p3 0.09 0.068 0.103)').to('oklch'),
        new Color('color(display-p3 0.113 0.082 0.134)').to('oklch'),
        new Color('color(display-p3 0.175 0.112 0.224)').to('oklch'),
        new Color('color(display-p3 0.224 0.137 0.297)').to('oklch'),
        new Color('color(display-p3 0.264 0.167 0.349)').to('oklch'),
        new Color('color(display-p3 0.311 0.208 0.406)').to('oklch'),
        new Color('color(display-p3 0.381 0.266 0.496)').to('oklch'),
        new Color('color(display-p3 0.49 0.349 0.649)').to('oklch'),
        new Color('color(display-p3 0.523 0.318 0.751)').to('oklch'),
        new Color('color(display-p3 0.57 0.373 0.791)').to('oklch'),
        new Color('color(display-p3 0.8 0.62 1)').to('oklch'),
        new Color('color(display-p3 0.913 0.854 0.971)').to('oklch'),
      ],
      violet: [
        new Color('color(display-p3 0.077 0.071 0.118)').to('oklch'),
        new Color('color(display-p3 0.101 0.084 0.141)').to('oklch'),
        new Color('color(display-p3 0.154 0.123 0.256)').to('oklch'),
        new Color('color(display-p3 0.191 0.148 0.345)').to('oklch'),
        new Color('color(display-p3 0.226 0.182 0.396)').to('oklch'),
        new Color('color(display-p3 0.269 0.223 0.449)').to('oklch'),
        new Color('color(display-p3 0.326 0.277 0.53)').to('oklch'),
        new Color('color(display-p3 0.399 0.346 0.656)').to('oklch'),
        new Color('color(display-p3 0.417 0.341 0.784)').to('oklch'),
        new Color('color(display-p3 0.477 0.402 0.823)').to('oklch'),
        new Color('color(display-p3 0.72 0.65 1)').to('oklch'),
        new Color('color(display-p3 0.883 0.867 0.986)').to('oklch'),
      ],
      iris: [
        new Color('color(display-p3 0.075 0.075 0.114)').to('oklch'),
        new Color('color(display-p3 0.089 0.086 0.14)').to('oklch'),
        new Color('color(display-p3 0.128 0.134 0.272)').to('oklch'),
        new Color('color(display-p3 0.153 0.165 0.382)').to('oklch'),
        new Color('color(display-p3 0.192 0.201 0.44)').to('oklch'),
        new Color('color(display-p3 0.239 0.241 0.491)').to('oklch'),
        new Color('color(display-p3 0.291 0.289 0.565)').to('oklch'),
        new Color('color(display-p3 0.35 0.345 0.673)').to('oklch'),
        new Color('color(display-p3 0.357 0.357 0.81)').to('oklch'),
        new Color('color(display-p3 0.428 0.416 0.843)').to('oklch'),
        new Color('color(display-p3 0.685 0.662 1)').to('oklch'),
        new Color('color(display-p3 0.878 0.875 0.986)').to('oklch'),
      ],
      indigo: [
        new Color('color(display-p3 0.068 0.074 0.118)').to('oklch'),
        new Color('color(display-p3 0.081 0.089 0.144)').to('oklch'),
        new Color('color(display-p3 0.105 0.141 0.275)').to('oklch'),
        new Color('color(display-p3 0.129 0.18 0.369)').to('oklch'),
        new Color('color(display-p3 0.163 0.22 0.439)').to('oklch'),
        new Color('color(display-p3 0.203 0.262 0.5)').to('oklch'),
        new Color('color(display-p3 0.245 0.309 0.575)').to('oklch'),
        new Color('color(display-p3 0.285 0.362 0.674)').to('oklch'),
        new Color('color(display-p3 0.276 0.384 0.837)').to('oklch'),
        new Color('color(display-p3 0.354 0.445 0.866)').to('oklch'),
        new Color('color(display-p3 0.63 0.69 1)').to('oklch'),
        new Color('color(display-p3 0.848 0.881 0.99)').to('oklch'),
      ],
      blue: [
        new Color('color(display-p3 0.057 0.081 0.122)').to('oklch'),
        new Color('color(display-p3 0.072 0.098 0.147)').to('oklch'),
        new Color('color(display-p3 0.078 0.154 0.27)').to('oklch'),
        new Color('color(display-p3 0.033 0.197 0.37)').to('oklch'),
        new Color('color(display-p3 0.08 0.245 0.441)').to('oklch'),
        new Color('color(display-p3 0.14 0.298 0.511)').to('oklch'),
        new Color('color(display-p3 0.195 0.361 0.6)').to('oklch'),
        new Color('color(display-p3 0.239 0.434 0.72)').to('oklch'),
        new Color('color(display-p3 0.247 0.556 0.969)').to('oklch'),
        new Color('color(display-p3 0.344 0.612 0.973)').to('oklch'),
        new Color('color(display-p3 0.49 0.72 1)').to('oklch'),
        new Color('color(display-p3 0.788 0.898 0.99)').to('oklch'),
      ],
      cyan: [
        new Color('color(display-p3 0.053 0.085 0.098)').to('oklch'),
        new Color('color(display-p3 0.072 0.105 0.122)').to('oklch'),
        new Color('color(display-p3 0.073 0.168 0.209)').to('oklch'),
        new Color('color(display-p3 0.063 0.216 0.277)').to('oklch'),
        new Color('color(display-p3 0.091 0.267 0.336)').to('oklch'),
        new Color('color(display-p3 0.137 0.324 0.4)').to('oklch'),
        new Color('color(display-p3 0.186 0.398 0.484)').to('oklch'),
        new Color('color(display-p3 0.23 0.496 0.6)').to('oklch'),
        new Color('color(display-p3 0.282 0.627 0.765)').to('oklch'),
        new Color('color(display-p3 0.331 0.675 0.801)').to('oklch'),
        new Color('color(display-p3 0.446 0.79 0.887)').to('oklch'),
        new Color('color(display-p3 0.757 0.919 0.962)').to('oklch'),
      ],
      teal: [
        new Color('color(display-p3 0.059 0.083 0.079)').to('oklch'),
        new Color('color(display-p3 0.075 0.11 0.107)').to('oklch'),
        new Color('color(display-p3 0.087 0.175 0.165)').to('oklch'),
        new Color('color(display-p3 0.087 0.227 0.214)').to('oklch'),
        new Color('color(display-p3 0.12 0.277 0.261)').to('oklch'),
        new Color('color(display-p3 0.162 0.335 0.314)').to('oklch'),
        new Color('color(display-p3 0.205 0.406 0.379)').to('oklch'),
        new Color('color(display-p3 0.245 0.489 0.453)').to('oklch'),
        new Color('color(display-p3 0.297 0.637 0.581)').to('oklch'),
        new Color('color(display-p3 0.319 0.69 0.62)').to('oklch'),
        new Color('color(display-p3 0.388 0.835 0.719)').to('oklch'),
        new Color('color(display-p3 0.734 0.934 0.87)').to('oklch'),
      ],
      jade: [
        new Color('color(display-p3 0.059 0.083 0.071)').to('oklch'),
        new Color('color(display-p3 0.078 0.11 0.094)').to('oklch'),
        new Color('color(display-p3 0.091 0.176 0.138)').to('oklch'),
        new Color('color(display-p3 0.102 0.228 0.177)').to('oklch'),
        new Color('color(display-p3 0.133 0.279 0.221)').to('oklch'),
        new Color('color(display-p3 0.174 0.334 0.273)').to('oklch'),
        new Color('color(display-p3 0.219 0.402 0.335)').to('oklch'),
        new Color('color(display-p3 0.263 0.488 0.411)').to('oklch'),
        new Color('color(display-p3 0.319 0.63 0.521)').to('oklch'),
        new Color('color(display-p3 0.338 0.68 0.555)').to('oklch'),
        new Color('color(display-p3 0.4 0.835 0.656)').to('oklch'),
        new Color('color(display-p3 0.734 0.934 0.838)').to('oklch'),
      ],
      green: [
        new Color('color(display-p3 0.062 0.083 0.071)').to('oklch'),
        new Color('color(display-p3 0.079 0.106 0.09)').to('oklch'),
        new Color('color(display-p3 0.1 0.173 0.133)').to('oklch'),
        new Color('color(display-p3 0.115 0.229 0.166)').to('oklch'),
        new Color('color(display-p3 0.147 0.282 0.206)').to('oklch'),
        new Color('color(display-p3 0.185 0.338 0.25)').to('oklch'),
        new Color('color(display-p3 0.227 0.403 0.298)').to('oklch'),
        new Color('color(display-p3 0.27 0.479 0.351)').to('oklch'),
        new Color('color(display-p3 0.332 0.634 0.442)').to('oklch'),
        new Color('color(display-p3 0.357 0.682 0.474)').to('oklch'),
        new Color('color(display-p3 0.434 0.828 0.573)').to('oklch'),
        new Color('color(display-p3 0.747 0.938 0.807)').to('oklch'),
      ],
      grass: [
        new Color('color(display-p3 0.062 0.083 0.067)').to('oklch'),
        new Color('color(display-p3 0.083 0.103 0.085)').to('oklch'),
        new Color('color(display-p3 0.118 0.163 0.122)').to('oklch'),
        new Color('color(display-p3 0.142 0.225 0.15)').to('oklch'),
        new Color('color(display-p3 0.178 0.279 0.186)').to('oklch'),
        new Color('color(display-p3 0.217 0.337 0.224)').to('oklch'),
        new Color('color(display-p3 0.258 0.4 0.264)').to('oklch'),
        new Color('color(display-p3 0.302 0.47 0.305)').to('oklch'),
        new Color('color(display-p3 0.38 0.647 0.378)').to('oklch'),
        new Color('color(display-p3 0.426 0.694 0.426)').to('oklch'),
        new Color('color(display-p3 0.535 0.807 0.542)').to('oklch'),
        new Color('color(display-p3 0.797 0.936 0.776)').to('oklch'),
      ],
      brown: [
        new Color('color(display-p3 0.071 0.067 0.059)').to('oklch'),
        new Color('color(display-p3 0.107 0.095 0.087)').to('oklch'),
        new Color('color(display-p3 0.151 0.13 0.115)').to('oklch'),
        new Color('color(display-p3 0.191 0.161 0.138)').to('oklch'),
        new Color('color(display-p3 0.235 0.194 0.162)').to('oklch'),
        new Color('color(display-p3 0.291 0.237 0.192)').to('oklch'),
        new Color('color(display-p3 0.365 0.295 0.232)').to('oklch'),
        new Color('color(display-p3 0.469 0.377 0.287)').to('oklch'),
        new Color('color(display-p3 0.651 0.505 0.368)').to('oklch'),
        new Color('color(display-p3 0.697 0.557 0.423)').to('oklch'),
        new Color('color(display-p3 0.835 0.715 0.597)').to('oklch'),
        new Color('color(display-p3 0.938 0.885 0.802)').to('oklch'),
      ],
      bronze: [
        new Color('color(display-p3 0.076 0.067 0.063)').to('oklch'),
        new Color('color(display-p3 0.106 0.097 0.093)').to('oklch'),
        new Color('color(display-p3 0.147 0.132 0.125)').to('oklch'),
        new Color('color(display-p3 0.185 0.166 0.156)').to('oklch'),
        new Color('color(display-p3 0.227 0.202 0.19)').to('oklch'),
        new Color('color(display-p3 0.278 0.246 0.23)').to('oklch'),
        new Color('color(display-p3 0.343 0.302 0.281)').to('oklch'),
        new Color('color(display-p3 0.426 0.374 0.347)').to('oklch'),
        new Color('color(display-p3 0.611 0.507 0.455)').to('oklch'),
        new Color('color(display-p3 0.66 0.556 0.504)').to('oklch'),
        new Color('color(display-p3 0.81 0.707 0.655)').to('oklch'),
        new Color('color(display-p3 0.921 0.88 0.854)').to('oklch'),
      ],
      gold: [
        new Color('color(display-p3 0.071 0.071 0.067)').to('oklch'),
        new Color('color(display-p3 0.104 0.101 0.09)').to('oklch'),
        new Color('color(display-p3 0.141 0.136 0.122)').to('oklch'),
        new Color('color(display-p3 0.177 0.17 0.152)').to('oklch'),
        new Color('color(display-p3 0.217 0.207 0.185)').to('oklch'),
        new Color('color(display-p3 0.265 0.252 0.225)').to('oklch'),
        new Color('color(display-p3 0.327 0.31 0.277)').to('oklch'),
        new Color('color(display-p3 0.407 0.384 0.342)').to('oklch'),
        new Color('color(display-p3 0.579 0.517 0.41)').to('oklch'),
        new Color('color(display-p3 0.628 0.566 0.463)').to('oklch'),
        new Color('color(display-p3 0.784 0.728 0.635)').to('oklch'),
        new Color('color(display-p3 0.906 0.887 0.855)').to('oklch'),
      ],
      sky: [
        new Color('color(display-p3 0.056 0.078 0.116)').to('oklch'),
        new Color('color(display-p3 0.075 0.101 0.149)').to('oklch'),
        new Color('color(display-p3 0.089 0.154 0.244)').to('oklch'),
        new Color('color(display-p3 0.106 0.207 0.323)').to('oklch'),
        new Color('color(display-p3 0.135 0.261 0.394)').to('oklch'),
        new Color('color(display-p3 0.17 0.322 0.469)').to('oklch'),
        new Color('color(display-p3 0.205 0.394 0.557)').to('oklch'),
        new Color('color(display-p3 0.232 0.48 0.665)').to('oklch'),
        new Color('color(display-p3 0.585 0.877 0.983)').to('oklch'),
        new Color('color(display-p3 0.718 0.925 0.991)').to('oklch'),
        new Color('color(display-p3 0.536 0.772 0.924)').to('oklch'),
        new Color('color(display-p3 0.799 0.947 0.993)').to('oklch'),
      ],
      mint: [
        new Color('color(display-p3 0.059 0.082 0.081)').to('oklch'),
        new Color('color(display-p3 0.068 0.104 0.105)').to('oklch'),
        new Color('color(display-p3 0.077 0.17 0.168)').to('oklch'),
        new Color('color(display-p3 0.068 0.224 0.22)').to('oklch'),
        new Color('color(display-p3 0.104 0.275 0.264)').to('oklch'),
        new Color('color(display-p3 0.154 0.332 0.313)').to('oklch'),
        new Color('color(display-p3 0.207 0.403 0.373)').to('oklch'),
        new Color('color(display-p3 0.258 0.49 0.441)').to('oklch'),
        new Color('color(display-p3 0.62 0.908 0.834)').to('oklch'),
        new Color('color(display-p3 0.725 0.954 0.898)').to('oklch'),
        new Color('color(display-p3 0.482 0.825 0.733)').to('oklch'),
        new Color('color(display-p3 0.807 0.955 0.887)').to('oklch'),
      ],
      lime: [
        new Color('color(display-p3 0.067 0.073 0.048)').to('oklch'),
        new Color('color(display-p3 0.086 0.1 0.067)').to('oklch'),
        new Color('color(display-p3 0.13 0.16 0.099)').to('oklch'),
        new Color('color(display-p3 0.172 0.214 0.126)').to('oklch'),
        new Color('color(display-p3 0.213 0.266 0.153)').to('oklch'),
        new Color('color(display-p3 0.257 0.321 0.182)').to('oklch'),
        new Color('color(display-p3 0.307 0.383 0.215)').to('oklch'),
        new Color('color(display-p3 0.365 0.456 0.25)').to('oklch'),
        new Color('color(display-p3 0.78 0.928 0.466)').to('oklch'),
        new Color('color(display-p3 0.865 0.995 0.519)').to('oklch'),
        new Color('color(display-p3 0.771 0.893 0.485)').to('oklch'),
        new Color('color(display-p3 0.905 0.966 0.753)').to('oklch'),
      ],
      yellow: [
        new Color('color(display-p3 0.078 0.069 0.047)').to('oklch'),
        new Color('color(display-p3 0.103 0.094 0.063)').to('oklch'),
        new Color('color(display-p3 0.168 0.137 0.039)').to('oklch'),
        new Color('color(display-p3 0.209 0.169 0)').to('oklch'),
        new Color('color(display-p3 0.255 0.209 0)').to('oklch'),
        new Color('color(display-p3 0.31 0.261 0.07)').to('oklch'),
        new Color('color(display-p3 0.389 0.331 0.135)').to('oklch'),
        new Color('color(display-p3 0.497 0.42 0.182)').to('oklch'),
        new Color('color(display-p3 1 0.92 0.22)').to('oklch'),
        new Color('color(display-p3 1 1 0.456)').to('oklch'),
        new Color('color(display-p3 0.948 0.885 0.392)').to('oklch'),
        new Color('color(display-p3 0.959 0.934 0.731)').to('oklch'),
      ],
      amber: [
        new Color('color(display-p3 0.082 0.07 0.05)').to('oklch'),
        new Color('color(display-p3 0.111 0.094 0.064)').to('oklch'),
        new Color('color(display-p3 0.178 0.128 0.049)').to('oklch'),
        new Color('color(display-p3 0.239 0.156 0)').to('oklch'),
        new Color('color(display-p3 0.29 0.193 0)').to('oklch'),
        new Color('color(display-p3 0.344 0.245 0.076)').to('oklch'),
        new Color('color(display-p3 0.422 0.314 0.141)').to('oklch'),
        new Color('color(display-p3 0.535 0.399 0.189)').to('oklch'),
        new Color('color(display-p3 1 0.77 0.26)').to('oklch'),
        new Color('color(display-p3 1 0.87 0.15)').to('oklch'),
        new Color('color(display-p3 1 0.8 0.29)').to('oklch'),
        new Color('color(display-p3 0.984 0.909 0.726)').to('oklch'),
      ],
      orange: [
        new Color('color(display-p3 0.088 0.07 0.057)').to('oklch'),
        new Color('color(display-p3 0.113 0.089 0.061)').to('oklch'),
        new Color('color(display-p3 0.189 0.12 0.056)').to('oklch'),
        new Color('color(display-p3 0.262 0.132 0)').to('oklch'),
        new Color('color(display-p3 0.315 0.168 0.016)').to('oklch'),
        new Color('color(display-p3 0.376 0.219 0.088)').to('oklch'),
        new Color('color(display-p3 0.465 0.283 0.147)').to('oklch'),
        new Color('color(display-p3 0.601 0.359 0.201)').to('oklch'),
        new Color('color(display-p3 0.9 0.45 0.2)').to('oklch'),
        new Color('color(display-p3 0.98 0.51 0.23)').to('oklch'),
        new Color('color(display-p3 1 0.63 0.38)').to('oklch'),
        new Color('color(display-p3 0.98 0.883 0.775)').to('oklch'),
      ],
    },
  },
  neutral: {
    light: {
      gray: [
        new Color('color(display-p3 0.988 0.988 0.988)').to('oklch'),
        new Color('color(display-p3 0.975 0.975 0.975)').to('oklch'),
        new Color('color(display-p3 0.939 0.939 0.939)').to('oklch'),
        new Color('color(display-p3 0.908 0.908 0.908)').to('oklch'),
        new Color('color(display-p3 0.88 0.88 0.88)').to('oklch'),
        new Color('color(display-p3 0.849 0.849 0.849)').to('oklch'),
        new Color('color(display-p3 0.807 0.807 0.807)').to('oklch'),
        new Color('color(display-p3 0.732 0.732 0.732)').to('oklch'),
        new Color('color(display-p3 0.553 0.553 0.553)').to('oklch'),
        new Color('color(display-p3 0.512 0.512 0.512)').to('oklch'),
        new Color('color(display-p3 0.392 0.392 0.392)').to('oklch'),
        new Color('color(display-p3 0.125 0.125 0.125)').to('oklch'),
      ],
      mauve: [
        new Color('color(display-p3 0.991 0.988 0.992)').to('oklch'),
        new Color('color(display-p3 0.98 0.976 0.984)').to('oklch'),
        new Color('color(display-p3 0.946 0.938 0.952)').to('oklch'),
        new Color('color(display-p3 0.915 0.906 0.925)').to('oklch'),
        new Color('color(display-p3 0.886 0.876 0.901)').to('oklch'),
        new Color('color(display-p3 0.856 0.846 0.875)').to('oklch'),
        new Color('color(display-p3 0.814 0.804 0.84)').to('oklch'),
        new Color('color(display-p3 0.735 0.728 0.777)').to('oklch'),
        new Color('color(display-p3 0.555 0.549 0.596)').to('oklch'),
        new Color('color(display-p3 0.514 0.508 0.552)').to('oklch'),
        new Color('color(display-p3 0.395 0.388 0.424)').to('oklch'),
        new Color('color(display-p3 0.128 0.122 0.147)').to('oklch'),
      ],
      slate: [
        new Color('color(display-p3 0.988 0.988 0.992)').to('oklch'),
        new Color('color(display-p3 0.976 0.976 0.984)').to('oklch'),
        new Color('color(display-p3 0.94 0.941 0.953)').to('oklch'),
        new Color('color(display-p3 0.908 0.909 0.925)').to('oklch'),
        new Color('color(display-p3 0.88 0.881 0.901)').to('oklch'),
        new Color('color(display-p3 0.85 0.852 0.876)').to('oklch'),
        new Color('color(display-p3 0.805 0.808 0.838)').to('oklch'),
        new Color('color(display-p3 0.727 0.733 0.773)').to('oklch'),
        new Color('color(display-p3 0.547 0.553 0.592)').to('oklch'),
        new Color('color(display-p3 0.503 0.512 0.549)').to('oklch'),
        new Color('color(display-p3 0.379 0.392 0.421)').to('oklch'),
        new Color('color(display-p3 0.113 0.125 0.14)').to('oklch'),
      ],
      sage: [
        new Color('color(display-p3 0.986 0.992 0.988)').to('oklch'),
        new Color('color(display-p3 0.97 0.977 0.974)').to('oklch'),
        new Color('color(display-p3 0.935 0.944 0.94)').to('oklch'),
        new Color('color(display-p3 0.904 0.913 0.909)').to('oklch'),
        new Color('color(display-p3 0.875 0.885 0.88)').to('oklch'),
        new Color('color(display-p3 0.844 0.854 0.849)').to('oklch'),
        new Color('color(display-p3 0.8 0.811 0.806)').to('oklch'),
        new Color('color(display-p3 0.725 0.738 0.732)').to('oklch'),
        new Color('color(display-p3 0.531 0.556 0.546)').to('oklch'),
        new Color('color(display-p3 0.492 0.515 0.506)').to('oklch'),
        new Color('color(display-p3 0.377 0.395 0.389)').to('oklch'),
        new Color('color(display-p3 0.107 0.129 0.118)').to('oklch'),
      ],
      olive: [
        new Color('color(display-p3 0.989 0.992 0.989)').to('oklch'),
        new Color('color(display-p3 0.974 0.98 0.973)').to('oklch'),
        new Color('color(display-p3 0.939 0.945 0.937)').to('oklch'),
        new Color('color(display-p3 0.907 0.914 0.905)').to('oklch'),
        new Color('color(display-p3 0.878 0.885 0.875)').to('oklch'),
        new Color('color(display-p3 0.846 0.855 0.843)').to('oklch'),
        new Color('color(display-p3 0.803 0.812 0.8)').to('oklch'),
        new Color('color(display-p3 0.727 0.738 0.723)').to('oklch'),
        new Color('color(display-p3 0.541 0.556 0.532)').to('oklch'),
        new Color('color(display-p3 0.5 0.515 0.491)').to('oklch'),
        new Color('color(display-p3 0.38 0.395 0.374)').to('oklch'),
        new Color('color(display-p3 0.117 0.129 0.111)').to('oklch'),
      ],
      sand: [
        new Color('color(display-p3 0.992 0.992 0.989)').to('oklch'),
        new Color('color(display-p3 0.977 0.977 0.973)').to('oklch'),
        new Color('color(display-p3 0.943 0.942 0.936)').to('oklch'),
        new Color('color(display-p3 0.913 0.912 0.903)').to('oklch'),
        new Color('color(display-p3 0.885 0.883 0.873)').to('oklch'),
        new Color('color(display-p3 0.854 0.852 0.839)').to('oklch'),
        new Color('color(display-p3 0.813 0.81 0.794)').to('oklch'),
        new Color('color(display-p3 0.738 0.734 0.713)').to('oklch'),
        new Color('color(display-p3 0.553 0.553 0.528)').to('oklch'),
        new Color('color(display-p3 0.511 0.511 0.488)').to('oklch'),
        new Color('color(display-p3 0.388 0.388 0.37)').to('oklch'),
        new Color('color(display-p3 0.129 0.126 0.111)').to('oklch'),
      ],
    },
    dark: {
      gray: [
        new Color('color(display-p3 0.067 0.067 0.067)').to('oklch'),
        new Color('color(display-p3 0.098 0.098 0.098)').to('oklch'),
        new Color('color(display-p3 0.135 0.135 0.135)').to('oklch'),
        new Color('color(display-p3 0.163 0.163 0.163)').to('oklch'),
        new Color('color(display-p3 0.192 0.192 0.192)').to('oklch'),
        new Color('color(display-p3 0.228 0.228 0.228)').to('oklch'),
        new Color('color(display-p3 0.283 0.283 0.283)').to('oklch'),
        new Color('color(display-p3 0.375 0.375 0.375)').to('oklch'),
        new Color('color(display-p3 0.431 0.431 0.431)').to('oklch'),
        new Color('color(display-p3 0.484 0.484 0.484)').to('oklch'),
        new Color('color(display-p3 0.706 0.706 0.706)').to('oklch'),
        new Color('color(display-p3 0.933 0.933 0.933)').to('oklch'),
      ],
      mauve: [
        new Color('color(display-p3 0.07 0.067 0.074)').to('oklch'),
        new Color('color(display-p3 0.101 0.098 0.105)').to('oklch'),
        new Color('color(display-p3 0.138 0.134 0.144)').to('oklch'),
        new Color('color(display-p3 0.167 0.161 0.175)').to('oklch'),
        new Color('color(display-p3 0.196 0.189 0.206)').to('oklch'),
        new Color('color(display-p3 0.232 0.225 0.245)').to('oklch'),
        new Color('color(display-p3 0.286 0.277 0.302)').to('oklch'),
        new Color('color(display-p3 0.383 0.373 0.408)').to('oklch'),
        new Color('color(display-p3 0.434 0.428 0.467)').to('oklch'),
        new Color('color(display-p3 0.487 0.48 0.519)').to('oklch'),
        new Color('color(display-p3 0.707 0.7 0.735)').to('oklch'),
        new Color('color(display-p3 0.933 0.933 0.94)').to('oklch'),
      ],
      slate: [
        new Color('color(display-p3 0.067 0.067 0.074)').to('oklch'),
        new Color('color(display-p3 0.095 0.098 0.105)').to('oklch'),
        new Color('color(display-p3 0.13 0.135 0.145)').to('oklch'),
        new Color('color(display-p3 0.156 0.163 0.176)').to('oklch'),
        new Color('color(display-p3 0.183 0.191 0.206)').to('oklch'),
        new Color('color(display-p3 0.215 0.226 0.244)').to('oklch'),
        new Color('color(display-p3 0.265 0.28 0.302)').to('oklch'),
        new Color('color(display-p3 0.357 0.381 0.409)').to('oklch'),
        new Color('color(display-p3 0.415 0.431 0.463)').to('oklch'),
        new Color('color(display-p3 0.469 0.483 0.514)').to('oklch'),
        new Color('color(display-p3 0.692 0.704 0.728)').to('oklch'),
        new Color('color(display-p3 0.93 0.933 0.94)').to('oklch'),
      ],
      sage: [
        new Color('color(display-p3 0.064 0.07 0.067)').to('oklch'),
        new Color('color(display-p3 0.092 0.098 0.094)').to('oklch'),
        new Color('color(display-p3 0.128 0.135 0.131)').to('oklch'),
        new Color('color(display-p3 0.155 0.164 0.159)').to('oklch'),
        new Color('color(display-p3 0.183 0.193 0.188)').to('oklch'),
        new Color('color(display-p3 0.218 0.23 0.224)').to('oklch'),
        new Color('color(display-p3 0.269 0.285 0.277)').to('oklch'),
        new Color('color(display-p3 0.362 0.382 0.373)').to('oklch'),
        new Color('color(display-p3 0.398 0.438 0.421)').to('oklch'),
        new Color('color(display-p3 0.453 0.49 0.474)').to('oklch'),
        new Color('color(display-p3 0.685 0.709 0.697)').to('oklch'),
        new Color('color(display-p3 0.927 0.933 0.93)').to('oklch'),
      ],
      olive: [
        new Color('color(display-p3 0.067 0.07 0.063)').to('oklch'),
        new Color('color(display-p3 0.095 0.098 0.091)').to('oklch'),
        new Color('color(display-p3 0.131 0.135 0.126)').to('oklch'),
        new Color('color(display-p3 0.158 0.163 0.153)').to('oklch'),
        new Color('color(display-p3 0.186 0.192 0.18)').to('oklch'),
        new Color('color(display-p3 0.221 0.229 0.215)').to('oklch'),
        new Color('color(display-p3 0.273 0.284 0.266)').to('oklch'),
        new Color('color(display-p3 0.365 0.382 0.359)').to('oklch'),
        new Color('color(display-p3 0.414 0.438 0.404)').to('oklch'),
        new Color('color(display-p3 0.467 0.49 0.458)').to('oklch'),
        new Color('color(display-p3 0.69 0.709 0.682)').to('oklch'),
        new Color('color(display-p3 0.927 0.933 0.926)').to('oklch'),
      ],
      sand: [
        new Color('color(display-p3 0.067 0.067 0.063)').to('oklch'),
        new Color('color(display-p3 0.098 0.098 0.094)').to('oklch'),
        new Color('color(display-p3 0.135 0.135 0.129)').to('oklch'),
        new Color('color(display-p3 0.164 0.163 0.156)').to('oklch'),
        new Color('color(display-p3 0.193 0.192 0.183)').to('oklch'),
        new Color('color(display-p3 0.23 0.229 0.217)').to('oklch'),
        new Color('color(display-p3 0.285 0.282 0.267)').to('oklch'),
        new Color('color(display-p3 0.384 0.378 0.357)').to('oklch'),
        new Color('color(display-p3 0.434 0.428 0.403)').to('oklch'),
        new Color('color(display-p3 0.487 0.481 0.456)').to('oklch'),
        new Color('color(display-p3 0.707 0.703 0.68)').to('oklch'),
        new Color('color(display-p3 0.933 0.933 0.926)').to('oklch'),
      ],
    },
  },
};
